import styles from './styles.module.scss';
import { useEffect, useState } from 'react';
import { AudioManager } from '@game-libs/audio-manager';
import { MenuEvents } from '@game-libs/models';
import { Dialog } from 'radix-ui';
import { EventsManager } from '@game-libs/events-manager';
import { MazeCrawler } from './MazeCrawler';
import { generateDungeon } from '@game-libs/exc-libs';
import { useGameDispatch } from '../../store/global-context';
import { useCurrencyStore } from '../../store/zustand/useCurrencyStore';
import { useDungeonCrawlerStore } from '../../store/zustand/useDungeonCrawlerStore';
import { getDungeonParamsForLevel } from './getDungeonParamsForLevel';
import { GUIActions } from '../../types/game-types';
import { DungeonEvents } from '../../types/game-events';

export const DungeonCrawler = () => {
  const { playSFXNow } = AudioManager();
  const dungeonCrawler = useDungeonCrawlerStore((state) => state);
  const gold = useCurrencyStore((state) => state.gold);
  const dispatch = useGameDispatch();
  const isOpen = dungeonCrawler.isOpen;

  const handleLoadDungeonCrawler = () => {

  };

  const handleOpenChange = (open: boolean) => {
    if (!open) {
      EventsManager().emit(DungeonEvents.EXIT_DUNGEON);
      dispatch({ type: GUIActions.CLOSE_DUNGEON_CRAWLER });
    }
  };

  const currentLevel = dungeonCrawler.currentLevel;

  const [dungeonData, setDungeonData] = useState(() => {
    const p = getDungeonParamsForLevel(currentLevel);
    return generateDungeon(p.rows, p.columns, p.numDoors, p.numRooms, p.numEnemies, p.numTreasures);
  });

  useEffect(() => {
    if (isOpen) {
      EventsManager().emit(DungeonEvents.ENTER_DUNGEON);
      const p = getDungeonParamsForLevel(currentLevel);
      setDungeonData(
        generateDungeon(p.rows, p.columns, p.numDoors, p.numRooms, p.numEnemies, p.numTreasures)
      );
    }
  }, [isOpen, currentLevel]);

  const { dungeon, enemies, treasures } = dungeonData;

  return (
    <Dialog.Root open={isOpen} onOpenChange={handleOpenChange}>
      <Dialog.Portal container={document.getElementById('ui-wrapper')}>
        <Dialog.Overlay className={styles.overlay} />
        <Dialog.Content
          onEscapeKeyDown={(e) => e.preventDefault()}
          onInteractOutside={(e) => e.preventDefault()}
          onCloseAutoFocus={() => playSFXNow(MenuEvents.CHANGE_VALUE)}
          onLoad={() => {
            handleLoadDungeonCrawler();
          }}
          className={styles.dungeonCrawlerContainer}
        >
          {/* <Dialog.Title className={styles.dungeonCrawlerHeader}>
            <Dialog.Close data-testid="close-dungeon-crawler-menu-button">
              <Icon hasBackground={false} large iconId={'close_button'} type={'buttons'} />
            </Dialog.Close>
          </Dialog.Title> */}
          <div className={styles.dungeonCrawlerContent}>
            <MazeCrawler
              mazeLayout={dungeon}
              enemiesPositions={enemies}
              treasuresPositions={treasures}
              dungeonLevel={currentLevel}
              playerGoldAtEntry={dungeonCrawler.goldWhenEntered ?? gold}
              onDungeonCompleteStart={(gold, grayKeys) => {
                dispatch({ type: GUIActions.ADD_DUNGEON_REWARDS, payload: { gold, keys: grayKeys } });
              }}
              onDungeonCompleteEnd={(completed) => {
                EventsManager().emit(DungeonEvents.EXIT_DUNGEON);
                dispatch({
                  type: GUIActions.CLOSE_DUNGEON_CRAWLER,
                  payload: completed ? { completed: true } : undefined,
                });
              }}
              onGiveUp={() => {
                EventsManager().emit(DungeonEvents.EXIT_DUNGEON);
                dispatch({ type: GUIActions.CLOSE_DUNGEON_CRAWLER });
              }}
              keysFromState={dungeonCrawler.keys}
              onConsumeGlobalKey={() => dispatch({ type: GUIActions.CONSUME_DUNGEON_KEY })}
            />
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
